import { render, staticRenderFns } from "./homeRelatorios.vue?vue&type=template&id=6c28c758"
import script from "./homeRelatorios.vue?vue&type=script&lang=ts"
export * from "./homeRelatorios.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports